import { LineChart, Line, ResponsiveContainer } from 'recharts';

export const LineGraph = ({ chart24Data }) => {
  const currentChange = Number(chart24Data[chart24Data.length - 1]?.amount);
  const lastChange = Number(chart24Data[0]?.amount);
  // console.log(currentChange > lastChange);
  return (
    <div className='w-[96px] h-[48px]'>
      <ResponsiveContainer width='100%' height='100%' aspect={4}>
        <LineChart width={100} height={20} data={chart24Data}>
          <Line
            type='linear'
            dataKey='amount'
            stroke={currentChange > lastChange ? '#03C04A' : '#FF0000'}
            strokeWidth={2}
            dot={false}
            activeDot={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};
